import { Text, Flex, Link, Button } from "@chakra-ui/react";
import { LoginForm } from "./LoginForm";
import { SsoSection } from "./SsoSection";
import { LoginOptionsDivider } from "./LoginOptionsDivider";
import { t } from "i18next";
import { FunnelComponentProps } from "../../funnel/types";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { DividerWithText } from "../../payments/components/DividerWithText";
import { TermsSection } from "./TermsSection";
import { AuthType } from "../../../hooks/useAuthMutations";
import { FunnelSteps } from "../../funnel/FunnelSteps";

export function LoginModalBody({
  onSuccess,
  setFunnelType,
  loading,
  loadingText,
  welcomeText,
  autoFocus,
  shouldShowSteps,
  stepCount,
  currentStep,
  stepText,
  stepDisplayText,
  showStepIndicators,
}: FunnelComponentProps & {
  loading?: boolean;
  loadingText?: string;
  welcomeText?: string;
  autoFocus?: boolean;
}) {
  return (
    <Flex direction="column" width="100%" padding="24px">
      {shouldShowSteps && (
        <FunnelSteps
          stepCount={stepCount}
          currentStep={currentStep}
          stepText={stepText}
          text={stepDisplayText}
          hideProgressIndicators={!showStepIndicators}
        />
      )}
      {welcomeText ? (
        <Text
          fontFamily="Bricolage Grotesque"
          fontWeight="500"
          lineHeight="31.2px"
          fontSize="24px"
          textAlign={"center"}
          color="dune.dune"
          alignSelf="center"
          pb="24px"
        >
          {welcomeText}
        </Text>
      ) : null}
      <LoginForm
        onSuccess={onSuccess}
        loading={loading}
        loadingText={loadingText}
        autoFocus={autoFocus}
      />
      <DividerWithText text="or" padding="16px 0px" />
      <SsoSection
        hideEmail={true}
        setFunnelType={setFunnelType}
        authType={AuthType.login}
        onAuthenticationSuccess={onSuccess}
      />
      <Flex direction="column" paddingTop="16px">
        <LoginOptionsDivider />
        <Button
          variant="tertiary"
          width="full"
          size="lg"
          onClick={() => setFunnelType(FUNNEL_TYPES.signup)}
        >
          Create account
        </Button>
      </Flex>
      <TermsSection />
    </Flex>
  );
}

export function LoginModalFooter() {
  return (
    <Flex padding="24px" justifyContent="center">
      <Text fontSize="14px" fontWeight={500} color={"neutral.300"} align="center">
        <Link
          textDecoration="underline"
          onClick={() => window.open("/auth/reset-password")}
        >
          {t("components.auth.forgotPassword")}
        </Link>
      </Text>
    </Flex>
  );
}
